import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { toast } from "react-toastify";
import bgImage from "../../assets/images/37.png";
import {
  settingInitialValues,
  settingValidationSchema,
} from "../../constants/auth.constants";
import {
  openAuthLink,
  serverUrl,
} from "../../platforms/AssistantDetails/Assistants.utils";

function Signup() {
  const navigate = useNavigate();

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      navigate("/sign-up/step-1", {
        state: { email: values.email, password: values.password },
      });
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="main" id="top">
      <div className="container-fluid bg-body-tertiary dark__bg-gray-1200">
        <div
          className="bg-holder bg-auth-card-overlay"
          style={{ backgroundImage: `url(${bgImage})` }}
        ></div>

        <div className="row flex-center position-relative min-vh-100 g-0 py-5">
          <div className="col-11 col-sm-10 col-xl-8">
            <div className="card border border-translucent auth-card">
              <div className="card-body pe-md-0">
                <div className="row align-items-center gx-0 gy-7">
                  <div className="col mx-auto py-8">
                    <div className="auth-form-box text-center">
                      <a
                        className="d-flex flex-center text-decoration-none mb-4"
                        href="/"
                      >
                        <div className="d-flex align-items-center fw-bolder fs-3 d-inline-block">
                          <img
                            src={
                              localStorage.getItem("phoenixTheme") === "dark"
                                ? "/assets/img/icons/logo.png"
                                : "/assets/img/icons/logo-dark.png"
                            }
                            alt="phoenix"
                            width="150"
                          />
                        </div>
                      </a>
                      <h3 className="text-body-highlight mb-1">Sign Up</h3>
                      <p className="text-body-tertiary mb-6">
                        Create your account to get started
                      </p>
                      <button
                        type="button"
                        className="btn btn-phoenix-secondary w-100 mb-2"
                        onClick={() => openAuthLink(`${serverUrl}/auth/google`)}
                      >
                        <img
                          src="/assets/img/icons/google.png"
                          alt="google"
                          className="mx-1"
                          style={{ width: "16px", height: "16px" }}
                        />
                        Signup with Google
                      </button>
                      <button
                        type="button"
                        className="btn btn-phoenix-secondary w-100 mb-2"
                        onClick={() => openAuthLink(`${serverUrl}/auth/github`)}
                      >
                        <img
                          src="/assets/img/icons/github.png"
                          alt="github"
                          className="mx-1 "
                          style={{ width: "16px", height: "16px" }}
                        />
                        Signup with Github
                      </button>
                      <div className="d-flex align-items-center mt-5 mb-4">
                        <div className="flex-grow-1 border-top"></div>
                        <span className="mx-3 small fw-bold text-body-tertiary">
                          or use email
                        </span>
                        <div className="flex-grow-1 border-top"></div>
                      </div>
                      <Formik
                        initialValues={settingInitialValues}
                        validationSchema={settingValidationSchema}
                        onSubmit={handleSubmit}
                      >
                        {({ isSubmitting }) => (
                          <Form noValidate>
                            <div className="mb-3 text-end">
                              <label className="form-label" htmlFor="email">
                                Email address
                              </label>
                              <Field
                                id="email"
                                name="email"
                                type="email"
                                placeholder="name@example.com"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="email"
                                component="div"
                                className="invalid-feedback d-block"
                              />
                            </div>

                            <div className="mb-3 text-end">
                              <label className="form-label" htmlFor="password">
                                Password
                              </label>
                              <Field
                                id="password"
                                name="password"
                                type="password"
                                placeholder="Password"
                                className="form-control"
                                autoComplete="new-password"
                              />
                              <ErrorMessage
                                name="password"
                                component="div"
                                className="invalid-feedback d-block"
                              />
                            </div>

                            <button
                              className="btn btn-primary d-block w-100 mt-3"
                              type="submit"
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? "Signing Up..." : "Sign Up"}
                            </button>
                          </Form>
                        )}
                      </Formik>

                      <div className="mt-4 text-center">
                        <p className="fs--1 text-600 mb-0">
                          Already have an account?{" "}
                          <Link to="/sign-in" className="text-primary fw-bold">
                            Login
                          </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Signup;
